module.exports = __webpack_public_path__ + "assets/img/w-c-11.b1713aab.png";